<template>
  <div class="export-excel-dialog">
    <el-dialog :title="$t('68')" :visible.sync="dialogVisible" @closed="handleClosed">
      <div v-load="loading" style="max-height: calc(80vh - 120px)">
        <el-form class="ui-form" v-if="showDatePicker">
          <el-form-item :label="$t('i18n.42a8db45f57a4a7f9881449896fabdf0')" required>
            <el-date-picker v-model="year" type="year" value-format="yyyy" :pickerOptions="pickerOptions" />
          </el-form-item>
        </el-form>
        <el-row type="flex">
          <el-col :span="12">
            <div class="tree-item tree-item-select">
              <div class="tree-item-select__header">
                <h1 class="header-title">{{ $t('i18n.79608fc91e5f41f79ad6ed4cb71e98f4') }}</h1>
                <div class="search-box">
                  <el-input prefix-icon="el-icon-search" v-model="filterText" clearable />
                </div>
              </div>
              <div class="tree-item-select__body">
                <div style="margin-left: 24px; line-height: 26px">
                  <el-checkbox v-model="isCheckAll" @change="handleCheckAll">{{ $t('91') }}</el-checkbox>
                </div>
                <el-tree
                  ref="ElTree"
                  node-key="id"
                  :data="selectTreeData"
                  :props="defaultProps"
                  show-checkbox
                  :filter-node-method="handleFilterNode"
                  @check="handleCheck"
                >
                  <div class="custom-tree-node" slot-scope="{ data }">
                    <el-tooltip class="item" effect="dark" :content="data[props.label]" placement="top">
                      <span>{{ data[props.label] }}</span>
                    </el-tooltip>
                  </div>
                </el-tree>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="tree-item tree-item-sort">
              <div class="tree-item-sort__header">
                <h1 class="header-title">{{ $t('i18n.370aa91c84394b859eb585510a37404b') }}</h1>
              </div>
              <div class="tree-item-sort__body">
                <SortTree ref="SortTree" :props="props" @delete="handleDelete" @drop="handleDrop" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('i18n.950d4a9d9ceb4af9ac991f3fa898f739') }}</el-button>
        <el-button type="primary" :disabled="exportDisabled" :loading="loading" @click="handleExport">{{
          $t('i18n.7ed7df25537b470a936f05235b3eec3c')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep, pick } from 'lodash-es'
import { flattenTree, buildTree } from './tree'
import SortTree from './SortTree.vue'

function createPickerOptions() {
  return {
    disabledDate(time) {
      return time.getTime() > Date.now()
    }
  }
}

export default {
  name: 'ExportExcelDialog',
  components: {
    SortTree
  },
  props: {
    /**
     * 接口相关字段定义
     */
    props: {
      type: Object,
      default() {
        return {
          label: 'txt',
          children: 'columns',
          sort: 'sort',
          seleted: 'is_selected',
          type: 'relation_type'
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      isCheckAll: false,
      showYear: false,
      year: '',
      filterText: '',
      selectTreeData: [],
      params: {},
      extraData: {},
      pickerOptions: createPickerOptions(),
      exportDisabled: false
    }
  },
  computed: {
    showDatePicker() {
      return +this.params[this.props.type] === 1
    },
    defaultProps() {
      return pick(this.props, ['label', 'children'])
    }
  },
  watch: {
    filterText(val) {
      this.$refs.ElTree.filter(val)
    }
  },
  methods: {
    /**
     * 组件初始化入口函数
     * @param {*} params 列表查询参数
     * @param {*} extraData 导出excel接口的附加参数
     */
    init(params, extraData) {
      if (!params) return
      this.dialogVisible = true
      this.loading = true
      this.params = params
      this.extraData = extraData
      this.$http({
        url: '/web/payroll_setting/getExcelItems',
        method: 'GET',
        params
      })
        .then(res => {
          let data = []
          const items = res.data.items
          const keys = Object.keys(items)
          keys.forEach(key => {
            const item = items[key]
            const sort = item[this.props.sort]
            data[sort] = {
              key,
              ...item
            }
          })
          data = data.filter(item => item)
          let count = 0
          const vm = this
          function loop(source, pid) {
            source.forEach(item => {
              count++
              item.id = count
              item.pid = pid
            })
            source.forEach(item => {
              if (item[vm.props.children]) {
                loop(item[vm.props.children], item.id)
              }
            })
          }
          loop(data, 0)
          this.selectTreeData = data
          this.$nextTick(() => {
            const list = flattenTree(this.props.children, cloneDeep(this.selectTreeData))
            const ids = list.filter(item => item[this.props.seleted] === 1).map(item => item.id)
            this.$refs.ElTree.setCheckedKeys(ids)
            this.handleCheck()
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 导出接口相关参数处理
     */
    buildData() {
      const sortTreeData = cloneDeep(this.$refs.SortTree.getData())
      const keys = sortTreeData.map(item => item.key)
      const items = {}
      keys.forEach((key, index) => {
        items[key] = sortTreeData[index]
      })
      const data = {
        items,
        ...this.extraData
      }
      if (this.showDatePicker) {
        data.year = this.year
      }
      return data
    },
    handleFilterNode(value, data) {
      if (!value) return true
      return data[this.props.label].indexOf(value) !== -1
    },
    handleAllowDrop(draggingNode, dropNode, type) {
      if (type === 'inner') {
        return false
      }
      if (draggingNode.data.pid !== dropNode.data.pid) {
        return false
      }
      return true
    },
    /**
     * SortTree组件派发的放置事件
     */
    handleDrop(parent) {
      const item = this.selectTreeData.find(item => item.id === parent.id)
      if (item) {
        const children = item[this.props.children]
        children.forEach(left => {
          parent[this.props.children].forEach(right => {
            if (left.id === right.id) {
              left[this.props.sort] = right[this.props.sort]
            }
          })
        })
      }
    },
    /**
     * 全选事件
     */
    handleCheckAll(v) {
      this.$refs.ElTree.setCheckedNodes(v ? this.selectTreeData : [])
      this.handleCheck()
    },
    /**
     * 单选事件
     */
    handleCheck() {
      const list = flattenTree(this.props.children, cloneDeep(this.selectTreeData))
      const totalLength = list.length
      const checkedNodes = this.$refs.ElTree.getCheckedNodes(false, true)
      const data = buildTree('id', 'pid', this.props.children, cloneDeep(checkedNodes))
      data.forEach(item => {
        let children = item[this.props.children]
        if (children) {
          // ascending order
          children = children.sort((a, b) => a[this.props.sort] - b[this.props.sort])
        }
      })
      this.$refs.SortTree.setData(data)
      this.isCheckAll = totalLength === checkedNodes.length
      this.exportDisabled = checkedNodes.length === 0
    },
    /**
     * SortTree组件派发的删除事件
     */
    handleDelete({ id }, b) {
      this.isCheckAll = false
      this.exportDisabled = b
      this.$refs.ElTree.setChecked(id, false, true)
    },
    /**
     * 导出事件
     */
    handleExport() {
      const data = this.buildData()
      if (this.showDatePicker && !this.year) {
        this.$message.warning(this.$t('i18n.de222615703a4c68a560a6348c3fe585'))
        return
      }
      const urls = new Map([
        // 年度归档
        [1, '/web/payroll_staff/exportYearIncomeArchive'],
        // 员工薪资
        [2, '/web/payroll_staff/exportPayInfoData'],
        // 工资表
        [3, '/web/payroll_sub_project_staff/downloadPaySheet'],
        // 合并工资表
        [4, '/web/payroll_sub_project_staff/downloadPaySheetCombined']
      ])
      const type = +this.params[this.props.type]
      const url = urls.get(type)
      if (!url) return
      this.loading = true
      this.$http({
        url,
        data
      })
        .then(() => {
          this.$message.success(this.$t('payroll_salary_30'))
          this.dialogVisible = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    /**
     * 重置组件相关数据
     */
    handleClosed() {
      this.year = ''
      this.filterText = ''
      this.isCheckAll = false
      this.selectTreeData = []
      this.$refs.SortTree.setData([])
    }
  }
}
</script>

<style lang="less" scoped>
.export-excel-dialog /deep/ .el-dialog__body {
  padding: 0;
}

.export-excel-dialog /deep/ .el-checkbox__label {
  color: #262626;
  font-weight: 400;
}

.ui-form {
  padding: 20px 24px 0 24px;
  border-bottom: 1px solid #eee;
}

.tree-item {
  margin-left: 24px;
  padding-bottom: 24px;
  height: 100%;
}

.tree-item-select {
  border-right: 1px solid #eee;
}

.search-box {
  margin-bottom: 10px;
  padding-right: 30px;

  /deep/ .el-input {
    max-width: 100%;
    width: 100%;
  }
}

.header-title {
  color: #303133;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
  padding-top: 15px;
  padding-bottom: 10px;
}

.custom-tree-node {
  font-weight: 400;
  color: #262626;
  max-width: 235px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
